import { h } from "preact";

import tracking from "../tracking/tracking";

export default function ShareButton({ title, type, url }) {
  let link = null;

  switch (type) {
    case "facebook":
      link = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}`;
      break;
    case "twitter":
      link = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
      break;
    case "linkedin":
      link = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        url
      )}`;
      break;
  }

  function trackClick() {
    tracking.track("shareButton.click", {
      title,
      url,
      name: `share.${type}`,
    });
  }

  return (
    <a
      href={link}
      target="blank"
      className="share-button mr-24"
      onClick={trackClick}
    >
      <img src={`/images/icon_social_${type}.svg`} width="48" height="48" />
    </a>
  );
}
